import { CSSProperties } from 'react';
import { Observable, Subject } from 'rxjs';
import { ProductQtyErrorCode } from '../../../../../../generated/graphql';
import { ILabel } from '../../../../models/common/label.model';
import { IPrice } from '../../../../models/common/pricing/price.model';
import { IStock } from '../../../../models/common/stock.model';
import { Locale } from '../../../../models/master/context-info.model';
import { IPLPProduct } from '../../../../models/plp/plp-products.model';
import { IPLPConfig, IPLPPricesItem } from '../../../../models/plp/product-list-page.model';
import { IPLPService } from '../../../../services/plp/plp-service';
import { IPricingService } from '../../../../services/pricing/pricing-service';
import { IPricesResult } from '../../../../services/pricing/pricing.dto';
import { IProductService } from '../../../../services/product/product-service';
import { PartsListRequest, PartsListResponse } from '../../../parts-list/parts-list.dto';

export type ListProductCardProps = {
  productService: IProductService;
  plpService: IPLPService;
  pricingService: IPricingService;
  config: IPLPConfig;
  labels?: ILabel[] | null;
  product: IPLPProduct;
  addToBasket: (stockCode: string, qty: number) => Promise<void>;
  onAddToPartsList: (stockCode: string, qty: number) => void;
  partsListReqSubject?: Subject<PartsListRequest>;
  partsListResObservable?: Observable<PartsListResponse>;
  incVat: boolean;
  isLast?: boolean;
  isSRP: boolean;
  style: CSSProperties;
  locale: Locale;
};

export type State = {
  quantity: number;
  totalPrice?: IPrice;
  unitPrice?: string;
  isValidQty: boolean;
  isBusy: boolean;
  isStockLoading: boolean;
  stock?: IStock | null;
  prices: IPLPPricesItem[];
  isOverflowMenuOpen: boolean;
  isDropdownOpen: boolean;
  unlistedQuantityPrice?: IPrice;
  unlistedQuantityUnitPrice?: string;
  isSearchingUnlistedQuantity?: boolean;
  defaultDropdownSelection?: number;
  errorMessage?: string;
  isInBasket: boolean;
};

export enum ListProductCardActionType {
  IsBusy = 'IsBusy',
  IsLoadingStock = 'IsLoadingStock',
  SetStockData = 'SetStockData',
  AddPriceData = 'AddPriceData',
  ToggleDropDownOpen = 'ToggleDropDownOpen',
  SetUnlistedQuantityPrice = 'SetUnlistedQuantityPrice',
  SetInvalidUnlistedQty = 'SetInvalidUnlistedQty',
  SearchUnlistedQuantity = 'SearchUnlistedQuantity',
  SearchListedQuantity = 'SearchListedQuantity',
  SetPrice = 'SetPrice',
}

export type Action =
  | { type: ListProductCardActionType.IsBusy; isBusy: boolean; isDropdownOpen?: boolean; isInBasket?: boolean }
  | { type: ListProductCardActionType.IsLoadingStock }
  | { type: ListProductCardActionType.SetStockData; stock?: IStock | null }
  | { type: ListProductCardActionType.AddPriceData; data: IPricesResult }
  | { type: ListProductCardActionType.ToggleDropDownOpen; isOpen: boolean }
  | { type: ListProductCardActionType.SetUnlistedQuantityPrice; qty?: number; price?: IPrice; unitPrice?: string; message?: string }
  | { type: ListProductCardActionType.SetInvalidUnlistedQty; quantity: number; errorCode: ProductQtyErrorCode }
  | { type: ListProductCardActionType.SearchUnlistedQuantity; quantity: number }
  | { type: ListProductCardActionType.SearchListedQuantity; quantity?: number }
  | { type: ListProductCardActionType.SetPrice; qty: number; totalPrice?: IPrice; unitPrice?: string };
